/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('core/navigation',['require','jquery','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var Navigation = Marionette.Module.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    startWithParent: false,
    queue: null,
    homeID: 'menu', // defaults to menu (id of menu/home paging object)

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('Navigation::initialize');

      if (options.homeID)
        this.homeID = options.homeID;
    },

    onStart: function(options)
    {
      options = options || { };

      this.app.radio.on('ui.button.pressed.home', $.proxy(this.home, this));
      this.app.radio.on('ui.button.pressed.next', $.proxy(this.next, this));
      this.app.radio.on('ui.button.pressed.back', $.proxy(this.prev, this));
      this.app.radio.on('ui.button.pressed.help', $.proxy(this.help, this));
      this.app.radio.on('ui.button.pressed.badge', $.proxy(this.badge, this));

      //console.log('nav cheats', this.app.$el);
      if (this.app.Cheats.settings.chatDebug)
      {
        this.app.radio.on('ui.button.pressed.debug', $.proxy(this.debug, this));
      }
      else
      {
        $('#header #btn-debug').hide();
      }

      if (this.queue)
      {
        this.go(this.queue);
        this.queue = null;
      }
      else
      {
        this.index();
      }
    },

    // NAVIGATION //

    go: function(pageRef)
    {
      //console.log('Navigation::go');
      this.disable();

      var page;

      // check for conclusion!
      var outro = this.app.module('Paging').find(this.app.config.settings.outro);
      if (outro && !outro.get('complete') && this.app.module('Paging').root.get('complete'))
      {
        //console.log('Loading conclusion:', outro);
        this.app.radio.trigger('load.pageobject', outro);
        return;
      }

      if (typeof pageRef === 'string') // lookup by id
        page = this.app.module('Paging').find(pageRef);
      else
        page = pageRef;

      ////console.log(page);

      if (page)
      {
        if (page.id === this.homeID)
          this.app.radio.trigger('go.home', page);
        else
          this.app.radio.trigger('load.pageobject', page);
      }
      else
      {
        console.warn('Warning: PagingObject [' + pageRef + '] not found.');
      }
    },

    disable: function()
    {
      ////console.log('Navigation::disable');

      this.app.radio.trigger('ui.update', { home: false, next: false, back: false });
    },

    index: function()
    {
      ////console.log('Navigation::index');

      // check for override
      if (this.app.urlParams.destination)
      {
        //console.log('* Router options detected, loading custom index...');

        if (this.app.urlParams.destination === this.homeID)
          this.home();
        else
          this.go(this.app.urlParams.destination);

        return;
      }

      // check for intro module first

      var intro = this.app.module('Paging').find(this.app.config.settings.intro);

      ////console.log(intro);

      if (intro && !intro.get('complete'))
        this.go(this.app.config.settings.intro);
      else
        this.home();
    },

    home: function()
    {
      this.go(this.homeID);
    },

    help: function()
    {
      /*var page = this.app.module('Paging').currentPage;
      ////console.log(page.get('view'));
      var pageView = page.get('view');
      if (pageView === 'menu')
      {
        this.app.radio.trigger('ui.update', { badge: false });
        this.go(this.app.config.mapSettings.menuInfoPage || 'menu_info');
      }
      else if (pageView === 'scenario-mapper')
      {
      }*/
      this.go('scenario_info');
    },

    badge: function()
    {
      //this.go('achievements_overlay');
    },

    debug: function()
    {
      if (this.app.Cheats.settings.chatDebug)
      {
        this.app.Cheats.settings.chatDebug = false;
        $('#header #btn-debug').html('debug off');
      }
      else
      {
        this.app.Cheats.settings.chatDebug = true;
        $('#header #btn-debug').html('debug on');
      }
    },

    next: function()
    {
      ////console.log('Navigation::next');

      var page = this.app.module('Paging').next();

      this.go(page);
    },

    prev: function()
    {
      ////console.log('Navigation::prev');

      var page = this.app.module('Paging').prev();

      this.go(page);
    },

    exit: function()
    {
      ////console.log('Navigation::exit');

      var response = confirm('Are you sure you want to exit?');

      if (response)
        window.top.window.close();
    }

  /*****************************************************************************************************************///}

  });

  return Navigation;

});

